export function eventInNode(event: Event, testedNode: Node) {
	let node = event.target as Node;

	while (node && node.parentNode) {
		if (node === testedNode) {
			return true;
		}
		node = node.parentNode;
	}

	return false;
}
